import { combineReducers } from 'redux'

import accessProfile from './accessProfile'
import analitycal from './analitycal'
import analitycalDashboard from './analitycalDashboard'
import analitycalParts from './analitycalParts'
import biDashboard from './biDashboard'
import billed from './billed'
import billedMonthComparative from './billedMonthComparative'
import biSellersDashboard from './biSellersDashboard'
import blip from './blip'
import call from './call'
import calls from './calls'
import circulars from './circulars'
import dailyEmails from './dailyEmails'
import dailySales from './dailySales'
import dashboard from './dashboard'
import dealership from './dealership'
import dealerships from './dealerships'
import department from './department'
import departments from './departments'
import equipment from './equipment'
import equipmentDashboard from './equipmentDashboard'
import equipments from './equipments'
import equipmentsTypes from './equipmentsTypes'
import equipmentType from './equipmentType'
import flashMessage from './flashMessage'
import functionDuck from './function'
import functions from './functions'
import helpdeskDashboard from './helpdeskDashboard'
import ipc from './ipc'
import islands from './islands'
import newsBoard from './newsBoard'
import newsSingle from './newsSingle'
import notifications from './notifications'
import objective from './objective'
import objectives from './objectives'
import organogram from './organogram'
import panoramas from './panoramas'
import pops from './pops'
import profile from './profile'
import quiz from './quiz'
import quizzes from './quizzes'
import receipts from './receipts'
import rhDashboard from './rhDashboard'
import rhMonthComparative from './rhMonthComparative'
import salesGoals from './salesGoals'
import sellers from './sellers'
import session from './session'
import status from './status'
import statusList from './statusList'
import superior from './superior'
import superiors from './superiors'
import surveys from './surveys'
import user from './user'
import users from './users'
import usersRamal from './usersRamal'

export default combineReducers({
  accessProfile,
  analitycal,
  analitycalDashboard,
  analitycalParts,
  biDashboard,
  billed,
  billedMonthComparative,
  biSellersDashboard,
  blip,
  call,
  calls,
  circulars,
  dailyEmails,
  dailySales,
  dashboard,
  dealership,
  dealerships,
  department,
  departments,
  equipment,
  equipmentDashboard,
  equipments,
  equipmentsTypes,
  equipmentType,
  flashMessage,
  functionDuck,
  functions,
  helpdeskDashboard,
  ipc,
  islands,
  newsBoard,
  newsSingle,
  notifications,
  objective,
  objectives,
  organogram,
  panorama: panoramas,
  pops,
  profile,
  quiz,
  quizzes,
  receipts,
  rhDashboard,
  rhMonthComparative,
  salesGoals,
  sellers,
  session,
  status,
  statusList,
  superior,
  superiors,
  surveys,
  user,
  users,
  usersRamal,
})
